export enum RoleType {
  SUPER_ADMIN = 1,
  AGENT = 2,
  MANAGER = 3,
}
